export const R_START = 'Start';
export const R_ABOUT_US = 'About Us';
export const R_SERVICES = 'Services';
export const R_STATISTICAL_PROGRAMMING = 'Statistical Programming';
export const R_CLINICAL_DATA_MANAGEMENT = 'Clinical Data Management';
export const R_MEDICAL_WRITING = 'Medical Writing';
export const R_REGULAR_AFFAIRS = 'Regulatory Affairs';
export const R_EXPERTISE = 'Expertise';
export const R_CAREERS = 'Careers';
export const R_VACANCIES = 'Vacancies';
export const R_VACANCIES_DETAILS = 'Vacancies Details';
export const R_APPLY = 'Apply Form';
export const R_APPLY_SAS = 'Apply Form Sas';
export const R_SAS_TRAININGS = 'SAS Trainings';
export const R_BLOG = 'Blog';
export const R_BLOG_DETAILS = 'Blog Details';
export const R_CONTACT_US = 'Contact Us';
